export const offers = {
    namespaced: true,
    state: {
        status: 'initial',
        list: [],
        pagination: {
            total: 0,
            current: 1
        },
        pdfStatus: 'initial'
    },
    mutations: {
        SET_STATUS(state, status) {
            state.status = status
        },
        SET_OFFERS(state, list) {
            state.list = list
        },
        SET_PAGINATION_TOTAL(state, total) {
            state.pagination.total = total
        },
        SET_PAGINATION_CURRENT(state, current) {
            state.pagination.current = current
        },
        SET_PDF_STATUS(state, pdfStatus) {
            state.pdfStatus = pdfStatus
        }
    },
    actions: {
        fetchList({ commit, getters, dispatch }) {
            commit('SET_STATUS', 'pending')
            return this.$api.get(`client/v2/offers/list?page=${getters.paginationCurrent}`).then(response => {
                commit('SET_OFFERS', response.data.data.items)
                commit('SET_PAGINATION_TOTAL', response.data.data.metadata.pageCount)
                commit('SET_STATUS', 'idle')
            }).catch(() => {
                dispatch('resetFromInitialState', { module: 'invoices' }, { root: true })
                commit('SET_STATUS', 'idle')
            })
        },
        fetchPdf({ commit, getters, dispatch }, payload) {
            commit('SET_PDF_STATUS', `pending${payload.name}`)
            return this.$api.get(`client/v2/offers/pdf/${payload.slug}`, {
                responseType: 'arraybuffer'
            }).then(response => {
                if(response.status === 200) {
                    const file = new Blob([response.data], { type: 'application/pdf' })
                    const fileURL = URL.createObjectURL(file)
                    const link = document.createElement('a')
                    link.href = fileURL
                    link.download = `${payload.name}.pdf`
                    link.click()
                    commit('SET_PDF_STATUS', 'idle')
                }
            }).catch(error => {
                console.error(error)
            })
        },
        setListPage({ commit }, page) {
            commit('SET_PAGINATION_CURRENT', page)
        }
    },
    getters: {
        status: state => state.status,
        list: state => state.list,
        paginationTotal: state => state.pagination.total,
        paginationCurrent: state => state.pagination.current,
        pdfStatus: state => state.pdfStatus
    }
}
